import { defineStore } from "pinia"
import { apiV1 } from "@/config/axios"

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    dashboardData: {
      total: 0,
      uploaded: 0,
      processing: 0,
      failed: 0,
      processed: 0,
      verified: 0,
      completed: 0
    },
    cardsData: {},
    cardsCount: {},
    cardsCurrentPage: {},
    cardsLoading: {},
    hubUsers: [],
    selectedUserIds: []
  }),

  actions: {
    async getDashboardStats() {
      const response = await apiV1.get("/dashboard/stats")
      this.dashboardData = response.data
      return response.data
    },

    async getHubUsers() {
      const response = await apiV1.get("/manage-documents/updated-by-users")
      this.hubUsers = response.data
      return response.data
    },

    async getDashboardCards(status, page = 1, perPage = 25) {
      this.cardsLoading[status] = true
      try {
        const params = {
          status,
          per_page: perPage,
          page,
          updated_by: this.selectedUserIds
        }

        const response = await apiV1.get("/dashboard", { params })

        if (!this.cardsData[status]) {
          this.cardsData[status] = []
        }

        if (page === 1) {
          this.cardsData[status] = response.data.data || []
        } else {
          this.cardsData[status].push(...(response.data.data || []))
        }

        this.cardsCount[status] = response.data.meta.total || 0
        this.cardsCurrentPage[status] = response.data.meta.current_page || 1

        return response.data
      } finally {
        this.cardsLoading[status] = false
      }
    },

    async loadMoreCards(status) {
      const currentPage = this.cardsCurrentPage[status] || 1
      const nextPage = currentPage + 1
      const total = this.cardsCount[status] || 0
      const currentCount = (this.cardsData[status] || []).length

      if (currentCount >= total || this.cardsLoading[status]) {
        return
      }

      await this.getDashboardCards(status, nextPage, 25)
    },

    async refreshColumns(statuses) {
      if (!statuses || statuses.length === 0) return

      await Promise.all(
        statuses.map((status) => this.getDashboardCards(status, 1, 25))
      )

      await this.getHubUsers()

      if (this.selectedUserIds.length > 0) {
        const validUserIds = this.hubUsers.map((user) => user.id)
        const filteredUserIds = this.selectedUserIds.filter((userId) =>
          validUserIds.includes(userId)
        )

        if (filteredUserIds.length !== this.selectedUserIds.length) {
          this.selectedUserIds = filteredUserIds
        }
      }
    },

    setSelectedUsers(userIds) {
      this.selectedUserIds = userIds
    },

    updateDashboardData(data) {
      this.dashboardData = data.stats
    }
  }
})
